import React, { useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
//UI
import {
  DangerButton,
  InfoButton,
  SuccessButton,
  WarningButton,
} from "../../../../ui/buttons/Button";
import { Input, SearchInput, Textarea } from "../../../../ui/inputs/Input";
import { Dimmer } from "../../../spinner";
import { Mensaje, MensajeSiNo } from "../../../mensajes2";
import axios from "axios";
import {
  formatMoneda,
  seleccionarCampo,
  validaMonto,
  validaSoloNumero,
} from "../../../../util/varios";
import moment from "moment";
import CatalogoIncorporacionMueble from "../../../../catalogos/catalogoIncorporacionMueble";
import CatalogoMotivoDesincorporacion from "../../../../catalogos/catalogoMotivoDesincorporacion";
import CatalogoDesincorporacionMueble from "../../../../catalogos/catalogoDesincorporacionMueble ";
const op = require("../../../../modulos/datos");

export default function DesincorporacionBienesMuebles({
  show,
  setShow,
  setTabla,
}) {
  const token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));

  const btnCancela = useRef();
  const btnAcepta = useRef();

  const btnTab1 = useRef();
  const btnTab2 = useRef();
  const btnTab3 = useRef();
  const btnTab4 = useRef();

  const txtCodigoIncorporacion = useRef();

  const txtCodigo = useRef();
  const txtCodActivo = useRef();
  const txtDescripcionActivo = useRef();
  const txtTipoMaterial = useRef();
  const txtFecha = useRef();
  const txtCodOrden = useRef();
  const txtNumFactura = useRef();
  const txtFechaAdquisicion = useRef();
  const txtCodProveedor = useRef();
  const txtRif = useRef();
  const txtNombre = useRef();
  const txtIdUbicacion = useRef();
  const txtCodigoUbicacion = useRef();
  const txtDescripcionUbicacion = useRef();
  const txtOriginal = useRef();
  const txtMas = useRef();
  const txtMenos = useRef();
  const txtActual = useRef();
  const txtCodigoBien = useRef();
  const txtCodigoBienNacional = useRef();
  const txtMarca = useRef();
  const txtModelo = useRef();
  const txtAnio = useRef();
  const txtColor = useRef();
  const txtCapacidad = useRef();
  const txtTipo = useRef();
  const txtSeriales = useRef();
  const txtNumPieza = useRef();
  const txtPlaca = useRef();
  const txtUso = useRef();
  const txtAlto = useRef();
  const txtLargo = useRef();
  const txtAncho = useRef();
  const txtObservacion = useRef();
  const txtCedula = useRef();
  const txtNombreResponsa = useRef();
  const txtCodMotivo = useRef();
  const txtDescripcionMotivo = useRef();
  const txtValorInicial = useRef();
  const txtValorRescate = useRef();
  const txtDepresiacionMensual = useRef();
  const txtDepresiacionAcumulada = useRef();
  const txtValorLibros = useRef();
  const txtValorAdicion = useRef();
  const txtValorReexpresado = useRef();
  const txtCostoReposicion = useRef();

  const txtFechaDesincorporacion = useRef();
  const txtCodMotivoDesin = useRef();
  const txtDescripcionMotivoDesin = useRef();
  const txtObservacionDesincorporacion = useRef();

  const estilos = {
    tab: {
      borderBottomLeftRadius: 0.25,
      borderBottomRightRadius: 0.25,
      border: "solid rgba(5, 81, 130, 0.5)",
      borderBottom: "none",
    },
    contenido: {
      border: "solid rgba(5, 81, 130, 0.5)",
    },
  };

  const [tab, setTab] = useState(1);
  const [operacion, setOperacion] = useState(0);
  const [txtOperacion, setTxtOperacion] = useState("");
  const [activate, setActivate] = useState(false);
  const [visibleButton, setVisibleButton] = useState(true);
  const [disabledPrint, setDisabledPrint] = useState(true);
  const [disabledCode, setDisabledCode] = useState(true);
  const [mostrarCatalogoMotivoDes, setMostrarCatalogoMotivoDes] =
    useState(false);
  const [mostrarCatalogoIncorp, setMostrarCatalogoIncorp] = useState(false);
  const [mostrarCatalogoDesincorp, setMostrarCatalogoDesincorp] =
    useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [generaAsiento, setGeneraAsiento] = useState(false);
  const [idAsiAnt, setIdAsiAnt] = useState(0);
  const [idClaseBien, setIdClaseBien] = useState(0);
  const [idIncorpora, setIdIncorpora] = useState(0);

  const onChange = (e) => {
    if (e.target.value !== "") {
      e.target.value = e.target.value.toUpperCase();
    }
  };

  const onNextChange = (e) => {
    if (e.which === 13) {
      if (e.target.name === "codigoactivo") {
        txtDescripcionActivo.current.focus();
      } else if (e.target.name === "tipomaterial") {
        btnAcepta.current.focus();
      }
    }
  };

  const habilitarCampos = () => {
    txtCodigoIncorporacion.current.disabled = false;
    txtFechaDesincorporacion.current.disabled = false;
    txtCodMotivoDesin.current.disabled = false;
    txtDescripcionMotivoDesin.current.disabled = false;
    txtObservacionDesincorporacion.current.disabled = false;
  };

  const deshabilitarCampos = () => {
    btnTab1.current.disabled = true;
    btnTab2.current.disabled = true;
    btnTab3.current.disabled = true;
    btnTab4.current.disabled = true;
    txtCodigo.current.disabled = true;
    txtCodigoIncorporacion.current.disabled = true;
    txtFechaDesincorporacion.current.disabled = true;
    txtCodMotivoDesin.current.disabled = true;
    txtDescripcionMotivoDesin.current.disabled = true;
    txtObservacionDesincorporacion.current.disabled = true;
  };

  const blanquear = () => {
    txtCodigo.current.value = "";
    txtCodigoIncorporacion.current.value = "";
    txtCodActivo.current.value = "";
    txtDescripcionActivo.current.value = "";
    txtTipoMaterial.current.value = "";
    txtFecha.current.value = "";
    txtCodOrden.current.value = "";
    txtNumFactura.current.value = "";
    txtFechaAdquisicion.current.value = "";
    txtCodProveedor.current.value = "";
    txtRif.current.value = "";
    txtNombre.current.value = "";
    txtIdUbicacion.current.value = "";
    txtCodigoUbicacion.current.value = "";
    txtDescripcionUbicacion.current.value = "";
    txtOriginal.current.value = "0";
    txtMas.current.value = "0";
    txtMenos.current.value = "0";
    txtActual.current.value = "0";
    txtCodigoBien.current.value = "";
    txtCodigoBienNacional.current.value = "";
    txtMarca.current.value = "";
    txtModelo.current.value = "";
    txtAnio.current.value = "0";
    txtColor.current.value = "";
    txtCapacidad.current.value = "0";
    txtTipo.current.value = "";
    txtSeriales.current.value = "";
    txtNumPieza.current.value = "0";
    txtPlaca.current.value = "";
    txtUso.current.value = "";
    txtAlto.current.value = "0";
    txtLargo.current.value = "0";
    txtAncho.current.value = "0";
    txtObservacion.current.value = "";
    txtCedula.current.value = "";
    txtNombreResponsa.current.value = "";
    txtCodMotivo.current.value = "";
    txtDescripcionMotivo.current.value = "";
    txtValorInicial.current.value = "0,00";
    txtValorRescate.current.value = "0,00";
    txtDepresiacionMensual.current.value = "0,00";
    txtDepresiacionAcumulada.current.value = "0,00";
    txtValorLibros.current.value = "0,00";
    txtValorAdicion.current.value = "0,00";
    txtValorReexpresado.current.value = "0,00";
    txtCostoReposicion.current.value = "0,00";
    txtFechaDesincorporacion.current.value = "";
    txtCodMotivoDesin.current.value = "";
    txtDescripcionMotivoDesin.current.value = "";
    txtObservacionDesincorporacion.current.value = "";

    setTab(1);
    setOperacion(0);
    setTxtOperacion("");
    setVisibleButton(true);
    setDisabledPrint(true);
    setDisabledCode(true);
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setMensajesino({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });

    setActivate(false);
    setGeneraAsiento(false);
    setIdAsiAnt(0);
    setIdClaseBien(0);
  };

  const procesarRegistro = async (body) => {
    setActivate(true);
    const endpoint = `${op.conexion}/api/bienes/desincorporacionmueble/actualizar`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          console.log(response.data);
          
          let msm = "";
          if (operacion === 1) {
            msm =
              "registro " +
              response.data.desincorporacionmueble_act +
              " creado correctamente";
          } else if (operacion === 2) {
            msm =
              "registro " +
              response.data.desincorporacionmueble_act +
              " modificado correctamente";
          } else if (operacion === 3) {
            msm =
              "registro " +
              response.data.desincorporacionmueble_act +
              " eliminado correctamente";
          }

          const descripcion =
            "Para Registrar Desincorporacón de Bien Mueble con Desincorporación N° : " +
            response.data.desincorporacionmueble_act +
            ", Incorporación N°  : " +
            idIncorpora +
            " y Código del Bien N°: " +
            txtCodigoBien.current.value.toUpperCase();

          let ope = 0;

          if (generaAsiento) {
            if (idAsiAnt !== 0) {
              ope = 2;
            } else {
              ope = 1;
            }
          } else {
            ope = 3;
          }

          const datos = {
            ope: ope,
            idEfi: idefiscal,
            fecIni: moment.utc(txtFecha.current.value).format("YYYY-MM-DD"),
            valorInicial: parseFloat(
              txtValorInicial.current.value
                .replace(/\./g, "")
                .replace(",", "."),
            ),
            idIncorpora: response.data.desincorporacionmueble_act,
            codigobien: txtCodigoBien.current.value,
            descripcion: descripcion,
            idClaseBien: idClaseBien === null ? 0 : idClaseBien,
            idAsiAnt: idAsiAnt === null ? 0 : idAsiAnt,
          };

           await crearReversarAsiento({ datos });

          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: msm,
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        setActivate(false);
        let mensaje = "";
        if (error.response) {
          mensaje = error?.response?.data?.message;
        } else {
          mensaje = error.toString();
        }

        if (
          mensaje ===
          `duplicate key value violates unique constraint "desincorporacionmueble_act"`
        ) {
          mensaje = "Ya Existe un inmueble con ese codigo.";
        }

        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      });
  };

  const crearReversarAsiento = async (body) => {
    setActivate(true);
    const endpoint = `${op.conexion}/api/bienes/desincorporacionmueble/crear_reversar_asiento`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "asiento procesado exitosamente",
              icono: "exito",
            });
          }
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response) {
          mensaje = error?.response?.data?.message;
        } else {
          mensaje = error.toString();
        }

        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", "."),
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }
    if (event.target.value) {
      let e = event.target.value
        .replace(/\D/g, "")
        .replace(/([0-9])([0-9]{2})$/, "$1.$2")
        .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

      return formatMoneda(e);
    } else if (event.target.value === "0") {
      return "0,00";
    } else {
      return "0,00";
    }
  };

  const ValidarCampos = () => {
    let valido = true;

    if (operacion !== 1 && txtCodigo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "El Código no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      setTab(1);
      txtCodigo.current.focus();
    } else if (txtCodigoIncorporacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "El Código del Bien no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      setTab(1);
      txtCodigoIncorporacion.current.focus();
    } else if (txtCodActivo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "El Código del Activo no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      setTab(1);
      txtCodActivo.current.focus();
    } else if (txtDescripcionActivo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "La Descripción del Activo no debe estar vacia",
        icono: "informacion",
      });
      valido = false;
      setTab(1);
      txtCodActivo.current.focus();
    } else if (txtFechaDesincorporacion.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Favor Ingrese la Fecha de Desincorporacón",
        icono: "informacion",
      });
      valido = false;
      setTab(4);
      txtFechaDesincorporacion.current.focus();
    } else if (txtCodMotivoDesin.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "El Código del Motivo de Desincorporación no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      setTab(4);
      txtCodMotivoDesin.current.focus();
    } else if (txtDescripcionMotivoDesin.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto:
          "La Descripción del Motivo de Desincorporación no debe estar vacia",
        icono: "informacion",
      });
      valido = false;
      setTab(4);
      txtDescripcionMotivoDesin.current.focus();
    }

    return valido;
  };

  const onChangeValidar = async () => {
    let sigue = ValidarCampos();
    if (sigue) {
      const datos = {
        operacion: operacion,
        nid: txtCodigo.current.value === "" ? 0 : txtCodigo.current.value,
        idincorpora: txtCodigoIncorporacion.current.value,
        fecdesin: moment
          .utc(txtFechaDesincorporacion.current.value)
          .format("YYYY-MM-DD"),
        idmotivo: txtCodMotivoDesin.current.value,
        obser:
          txtObservacionDesincorporacion.current.value.trim().toString()
            .length > 700
            ? txtObservacionDesincorporacion.current.value
                .trim()
                .substring(0, 699)
                .toUpperCase()
            : txtObservacionDesincorporacion.current.value.trim().toUpperCase(),
        idIncorpora: idIncorpora,
      };

      await procesarRegistro({
        datos: datos,
      });
    }
  };

  const seleccionarRegistro = async () => {
    const campos = "*";
    const id = txtCodigo.current.value;
    const nomtab = "desincorporacionmueble";
    const nomid = "iddesincorporacionmueble";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;

            txtCodigoIncorporacion.current.value = data.idincorporacionmueble;
            txtFechaDesincorporacion.current.value = moment
              .utc(data.fechadesincorporacion)
              .format("YYYY-MM-DD");
            txtCodMotivoDesin.current.value = data.idmotivodesincorporacion;
            txtObservacionDesincorporacion.current.value =
              data.observaciondesincorporacion == null
                ? ""
                : data.observaciondesincorporacion.trim();

            setIdAsiAnt(data.idasiento);
            setDisabledCode(true);
            await seleccionarRegistroBien();
            await seleccionarRegistroMotivoDesincorporacion();
          } else {
            setActivate(false);
            blanquear();
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No exieste un registro con ese codigo",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRegistroBien = async () => {
    const campos = "*";
    const id = txtCodigoIncorporacion.current.value;
    const nomtab = "incorporacionmueble";
    const nomid = "idincorporacionmueble";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            if (data.statusbien === 1 && operacion === 1) {
              txtCodigoIncorporacion.current.value = "";
              btnTab1.current.disabled = false;
              btnTab2.current.disabled = true;
              btnTab3.current.disabled = true;
              btnTab4.current.disabled = true;
              setIdIncorpora(0);
              blanquear();
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Bien Mueble fue Desincorporado",
                icono: "informacion",
              });
            } else {
              setIdIncorpora(data.idincorporacionmueble);
              btnTab1.current.disabled = false;
              btnTab2.current.disabled = false;
              btnTab3.current.disabled = false;
              btnTab4.current.disabled = false;
              
              txtCodigo.current.disabled = true;
              txtCodActivo.current.value = data.idtipoactivo;
              if (op.espiritu === 7) {
                txtTipoMaterial.current.value =
                  data.tipomaterial === null ? "" : data.tipomaterial;
              }
              txtCodOrden.current.value =
                data.idordenpago == 0 ? "" : data.idordenpago;
              txtNumFactura.current.value =
                data.numfactura == null ? "" : data.numfactura.trim();
              txtCodProveedor.current.value =
                data.idproveedor == 0 ? "" : data.idproveedor;
              txtIdUbicacion.current.value = data.idubicacionbien;
              txtOriginal.current.value = data.vidautiloriginal;
              txtMas.current.value = data.vidautilmas;
              txtMenos.current.value = data.vidautilmenos;
              txtCodigoBien.current.value =
                data.codigobien == null ? "" : data.codigobien.trim();
              txtCodigoBienNacional.current.value =
                data.codigobiennacional == null
                  ? ""
                  : data.codigobiennacional.trim();

              txtMarca.current.value = data.marca === null ? "" : data.marca;
              txtModelo.current.value = data.modelo === null ? "" : data.modelo;
              txtAnio.current.value == data.anio;
              txtColor.current.value = data.color === null ? "" : data.color;
              txtCapacidad.current.value = data.capacidad;
              txtTipo.current.value = data.tipo === null ? "" : data.tipo;
              txtSeriales.current.value =
                data.seriales === null ? "" : data.seriales;
              txtNumPieza.current.value = data.numpiezas;
              txtPlaca.current.value = data.placa === null ? "" : data.placa;
              txtAlto.current.value = data.alto;
              txtLargo.current.value = data.largo;
              txtAncho.current.value = data.ancho;
              txtUso.current.value = data.uso === null ? "" : data.uso;
              txtObservacion.current.value =
                data.observacionincorporacion == null
                  ? ""
                  : data.observacionincorporacion.trim();

              txtCodMotivo.current.value = data.idmotivoincorporacion;
              txtValorInicial.current.value = formatMoneda(
                data.valorinicial.replace(",", "").replace(".", ","),
                ",",
                ".",
                2,
              );
              txtValorRescate.current.value = formatMoneda(
                data.valorrescate.replace(",", "").replace(".", ","),
                ",",
                ".",
                2,
              );
              txtDepresiacionMensual.current.value = formatMoneda(
                data.depresiacionmensual.replace(",", "").replace(".", ","),
                ",",
                ".",
                2,
              );
              txtDepresiacionAcumulada.current.value = formatMoneda(
                data.depresiacionacumulada.replace(",", "").replace(".", ","),
                ",",
                ".",
                2,
              );
              txtValorLibros.current.value = formatMoneda(
                data.valorlibros.replace(",", "").replace(".", ","),
                ",",
                ".",
                2,
              );
              txtValorAdicion.current.value = formatMoneda(
                data.valoradicion.replace(",", "").replace(".", ","),
                ",",
                ".",
                2,
              );
              txtValorReexpresado.current.value = formatMoneda(
                data.valorreexpresado.replace(",", "").replace(".", ","),
                ",",
                ".",
                2,
              );
              txtCostoReposicion.current.value = formatMoneda(
                data.costoreposicion.replace(",", "").replace(".", ","),
                ",",
                ".",
                2,
              );
              txtFecha.current.value = moment
                .utc(data.fechaincorporacion)
                .format("YYYY-MM-DD");
              txtFechaAdquisicion.current.value = moment
                .utc(data.fechaadquisicion)
                .format("YYYY-MM-DD");

              if (data.idtipoactivo !== 0 && data.idtipoactivo !== null) {
                await seleccionarRegistroTipoActivo();
              }

              if (data.idordenpago !== 0 && data.idordenpago !== null) {
                await seleccionarOrdenPago();
              }

              if (data.idproveedor !== 0 && data.idproveedor !== null) {
                await seleccionarRegistroProveedor();
              }

              if (data.idubicacionbien !== 0 && data.idubicacionbien !== null) {
                await seleccionarRegistroUbicacion();
              }

              if (
                data.idmotivoincorporacion !== 0 &&
                data.idmotivoincorporacion !== null
              ) {
                await seleccionarRegistroMotivo();
              }

              if (operacion === 2) {
                habilitarCampos();
              }

              if (operacion === 4) {
                setDisabledPrint(false);
              } else {
                setDisabledPrint(true);
              }
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Bien Mueble no existe",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarRegistroProveedor = async () => {
    const campos = "*";
    const id = txtCodProveedor.current.value;
    const nomtab = "proveedor";
    const nomid = "idproveedor";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;

            txtRif.current.value = data.rif;
            txtNombre.current.value = data.razonsocial;
          } else {
            txtCodProveedor.current.value = "";
            txtRif.current.value = "";
            txtNombre.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Proveedor no Existe",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarRegistroTipoActivo = async () => {
    const campos = "*";
    const id = txtCodActivo.current.value;
    const nomtab = "tipoactivo";
    const nomid = "idtipoactivo";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;

            if (data.tipobien === 1) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El el tipo de activo no es mueble",
                icono: "informacion",
              });
              txtCodActivo.current.value = "";
              txtCodActivo.current.focus();
              setIdClaseBien(0);
            } else {
              txtDescripcionActivo.current.value = data.descripcion;
              txtTipoMaterial.current.value =
                data.tipomaterial === null ? "" : data.tipomaterial;
              setIdClaseBien(data.idclasificabienes);
            }
          } else {
            txtCodActivo.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Tipo Activo no Existe",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarRegistroUbicacion = async () => {
    const campos = "u.*, (p.apellidos || ' ' || p.nombres) As nombre ";
    const id = txtIdUbicacion.current.value;
    const nomtab = "ubicacionbien u, persona p";
    const nomid = "idubicacionbien";
    const condic =
      " u.cedularesponsable = p.cedula AND ubicacionfisica = true ";

    const endpoint = `${op.conexion}/api/consulta/modelicondi?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&condic=${condic}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            const data = response.data[0];

            const cod =
              data.codigoubicacion.substring(0, 2) +
              "-" +
              data.codigoubicacion.substring(2, 4) +
              "-" +
              data.codigoubicacion.substring(4, 6) +
              "-" +
              data.codigoubicacion.substring(6, 8);

            txtCodigoUbicacion.current.value = cod;
            txtDescripcionUbicacion.current.value =
              data.descripcionubicacionbien;
            txtCedula.current.value = data.cedularesponsable;
            txtNombreResponsa.current.value = data.nombre;
          } else {
            txtIdUbicacion.current.value = "";
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "La ubicacion no Existe",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarRegistroMotivo = async () => {
    const campos = "*";
    const id = txtCodMotivo.current.value;
    const nomtab = "motivoincorporacion";
    const nomid = "idmotivoincorporacion";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            txtDescripcionMotivo.current.value =
              data.descripcionincorporacion.trim();
            setGeneraAsiento(data.afectaconta);
          } else {
            txtCodMotivo.current.value = "";
            txtDescripcionMotivo.current.value = "";
            setGeneraAsiento(false);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Motivo de Incorporación no Existe",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarRegistroMotivoDesincorporacion = async () => {
    const campos = "*";
    const id = txtCodMotivoDesin.current.value;
    const nomtab = "motivodesincorporacion";
    const nomid = "idmotivodesincorporacion";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            txtDescripcionMotivoDesin.current.value =
              data.descripciondesincorporacion.trim();
            setGeneraAsiento(data.afectaconta);
          } else {
            txtCodMotivoDesin.current.value = "";
            txtDescripcionMotivoDesin.current.value = "";
            setGeneraAsiento(false);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Motivo de Desincorporación no Existe",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionarOrdenPago = async () => {
    const id = txtCodOrden.current.value;
    const endpoint = `${op.conexion}/api/bienes/incorporacionmueble/seleccionar_ordenpago?&idordenpago=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;

            if (data.reversado === 1) {
              txtCodOrden.current.focus();
              txtCodOrden.current.value = "";

              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "La orden de pago fue reversada",
                icono: "informacion",
              });
            } else {
              if (data.numfactura) {
                txtNumFactura.current.value = data.numfactura;
              } else {
                txtNumFactura.current.value = "";
              }

              txtCodProveedor.current.value = data.idproveedor;
            }
          } else {
            txtNumFactura.current.focus();
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const validarCodigo = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtCodigo.current.blur();
        seleccionarRegistro();
      }
    }
  };

  const validarCodigoIncorporacion = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtCodigoIncorporacion.current.blur();
        seleccionarRegistroBien();
      }
    }
  };

  const validarCodigoMotivoDes = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtCodMotivoDesin.current.blur();
        seleccionarRegistroMotivoDesincorporacion();
      } else {
        txtCodMotivoDesin.current.value = "";
        txtDescripcionMotivoDesin.current.value = "";
      }
    }
  };

  const onHideCatalogoMotivoDes = (value = false) => {
    setMostrarCatalogoMotivoDes(false);
    if (value) {
      txtCodMotivoDesin.current.value = value.idmotivodesincorporacion;
      seleccionarRegistroMotivoDesincorporacion();
    }
  };

  const onHideCatalogoIncorp = (value = false) => {
    setMostrarCatalogoIncorp(false);
    if (value) {
      txtCodigoIncorporacion.current.value = value.idincorporacionmueble;
      seleccionarRegistroBien();
    }
  };

  const onHideCatalogoDesincorp = (value = false) => {
    setMostrarCatalogoDesincorp(false);
    if (value) {
      txtCodigo.current.value = value.iddesincorporacionmueble;
      seleccionarRegistro();
    }
  };

  const imprimirDesincorporacionBienMueble = () => {
    const reporte = "ListDesincorporacion";
    const dolar = 0.0;
    const bolivar = 0.0;
    const sql = "'" + txtCodigo.current.value + "'";
    const sql2 = dolar.toString();
    const sql3 = bolivar.toString();
    const titulo = "DESINCORPORACION DE BIENES NACIONALES";

    window.open(
      op.reportes +
        "/bienes?" +
        "reporte=" +
        reporte +
        "&ID=" +
        sql +
        "&DOLAR=" +
        sql2 +
        "&BOLIVAR=" +
        sql3 +
        "&TITULO=" +
        titulo,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  const onClickButton = async (value) => {
    if (value === 1) {
      setTab(1);
      setOperacion(1);
      setTxtOperacion("[Incluyendo]");
      setVisibleButton(false);
      setDisabledCode(true);
      habilitarCampos();
      txtFecha.current.value = moment.utc(fechasistema).format("YYYY-MM-DD");
      txtFechaAdquisicion.current.value = moment
        .utc(fechasistema)
        .format("YYYY-MM-DD");
      txtFechaDesincorporacion.current.value = moment
        .utc(fechasistema)
        .format("YYYY-MM-DD");
      btnTab1.current.disabled = false;
      btnTab2.current.disabled = false;
      btnTab3.current.disabled = false;
      btnTab4.current.disabled = false;
      setTimeout(() => {
        txtCodigoBien.current.focus();
      }, 200);
    } else if (value === 2) {
      setTab(1);
      setOperacion(2);
      setTxtOperacion("[Editando]");
      setVisibleButton(false);
      setDisabledCode(false);
      btnTab1.current.disabled = false;
      btnTab2.current.disabled = true;
      btnTab3.current.disabled = true;
      btnTab4.current.disabled = true;
      setTimeout(() => {
        txtCodigo.current.focus();
      }, 200);
    } else if (value === 3) {
      setTab(1);
      setOperacion(3);
      setTxtOperacion("[Eliminando]");
      setVisibleButton(false);
      setDisabledCode(false);
      btnTab1.current.disabled = false;
      btnTab2.current.disabled = true;
      btnTab3.current.disabled = true;
      btnTab4.current.disabled = true;
      setTimeout(() => {
        txtCodigo.current.focus();
      }, 200);
    } else if (value === 4) {
      setTab(1);
      setOperacion(4);
      setTxtOperacion("[Consultando]");
      setVisibleButton(false);
      setDisabledCode(false);
      btnTab1.current.disabled = false;
      btnTab2.current.disabled = true;
      btnTab3.current.disabled = true;
      btnTab4.current.disabled = true;
      setTimeout(() => {
        txtCodigo.current.focus();
      }, 200);
    } else if (value === 5) {
      setVisibleButton(false);
      await onChangeValidar();
    } else if (value === 6) {
      blanquear();
      deshabilitarCampos();
    } else if (value === 7) {
      imprimirDesincorporacionBienMueble();
    }
  };

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="xl" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">
          Desincorporación Bienes Inmuebles {txtOperacion}
        </h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body
        style={{
          height: 480,
        }}
      >
        <ul
          className="nav d-flex flex-wrap gap-1 align-items-center"
          id="ex-with-icons"
          role="tablist"
        >
          <li
            className="nav-item"
            onClick={() => setTab(1)}
            role="presentation"
          >
            <button
              className="nav-link text-white rounded p-2 bg-primary"
              style={tab === 1 ? estilos.tab : {}}
              ref={btnTab1}
              disabled
            >
              <i className="fas mx-2 fa-folder-minus"></i>Datos Generales
            </button>
          </li>
          <li
            className="nav-item"
            onClick={() => setTab(2)}
            role="presentation"
          >
            <button
              className="nav-link text-white rounded p-2 bg-primary"
              style={tab === 2 ? estilos.tab : {}}
              ref={btnTab2}
              disabled
            >
              {" "}
              <i className="fas mx-2 fa-money-bill"></i> Características del
              Inmueble
            </button>
          </li>

          <li
            className="nav-item"
            onClick={() => setTab(3)}
            role="presentation"
          >
            <button
              className="nav-link text-white rounded p-2 bg-primary"
              style={tab === 3 ? estilos.tab : {}}
              ref={btnTab3}
              disabled
            >
              {" "}
              <i className="fas mx-2 fa-money-bill"></i> Costos
            </button>
          </li>
          <li
            className="nav-item"
            onClick={() => setTab(4)}
            role="presentation"
          >
            <button
              className="nav-link text-white rounded p-2 bg-primary"
              style={tab === 4 ? estilos.tab : {}}
              ref={btnTab4}
              disabled
            >
              {" "}
              <i className="fas mx-2 fa-money-bill"></i> Datos de la
              Desincorporación
            </button>
          </li>
        </ul>

        <div className="tab-content mt-2" id="nav-tabContent">
          <div hidden={tab !== 1}>
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <div className="col-2 m-0 mb-2 p-0">
                <SearchInput
                  ref={txtCodigo}
                  disabled={disabledCode}
                  onKeyUp={validarCodigo}
                  onBlur={validarCodigo}
                  label="Id Sistema:"
                  name="codigo"
                  autoComplete="off"
                  disabledButton={disabledCode}
                  onClickButton={() => setMostrarCatalogoDesincorp(true)}
                />
              </div>
              <div className="col-2 m-0 mb-2 p-0">
                <SearchInput
                  ref={txtCodigoIncorporacion}
                  disabled={
                    operacion === 0 || operacion === 3 || operacion === 4
                  }
                  onKeyUp={validarCodigoIncorporacion}
                  onBlur={validarCodigoIncorporacion}
                  label="Código Bien:"
                  name="codbien"
                  autoComplete="off"
                  disabledButton={
                    operacion === 0 || operacion === 3 || operacion === 4
                  }
                  onClickButton={() => setMostrarCatalogoIncorp(true)}
                />
              </div>
              <div className="col-2 m-0 mb-2 p-0 pl-2">
                <Input
                  ref={txtCodActivo}
                  disabled
                  label="Id. Tipo Activo:"
                  name="codactivo"
                  autoComplete="off"
                />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2">
                <Textarea
                  ref={txtDescripcionActivo}
                  disabled
                  label="Descripción:"
                  name="descripcion"
                />
              </div>
              <div className="col-9 m-0 p-0">
                <Input
                  label="Tipo Material:"
                  name="tipomaterial"
                  ref={txtTipoMaterial}
                  disabled
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Fecha Incorporación:"
                  name="fecha"
                  type="date"
                  ref={txtFecha}
                  disabled
                  autoComplete="off"
                />
              </div>
              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos Orden Pago
                </legend>
                <div className="col-3 m-0 mb-2 p-0">
                  <Input
                    ref={txtCodOrden}
                    disabled
                    label="Cod. Orden Pago:"
                    name="codordenpago"
                    autoComplete="off"
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label="Factura:"
                    name="numfactura"
                    autoComplete="off"
                    ref={txtNumFactura}
                    disabled
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input
                    label="Fecha Adquisición:"
                    name="fechaadquisicion"
                    type="date"
                    autoComplete="off"
                    ref={txtFechaAdquisicion}
                    disabled
                  />
                </div>
                <div className="col-12 m-0 p-0 d-flex flex-wrap">
                  <div className="col-3 m-0 p-0">
                    <Input
                      ref={txtCodProveedor}
                      disabled
                      label="Cod. Proveedor:"
                      name="codproveedor"
                      autoComplete="off"
                    />
                  </div>
                  <div className="col-3 m-0 p-0 pl-2">
                    <Input
                      label="C.I. / RIF:"
                      name="cedula"
                      ref={txtRif}
                      disabled
                    />
                  </div>
                  <div className="col-6 m-0 p-0 pl-2">
                    <Input
                      label="Nombre / Razón Social:"
                      name="nombre"
                      ref={txtNombre}
                      disabled
                    />
                  </div>
                </div>
              </fieldset>
              <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos de la Ubicación
                </legend>
                <div className="col-2 m-0 p-0">
                  <Input
                    ref={txtIdUbicacion}
                    disabled
                    label="Id. Ubicación:"
                    name="codubicacion"
                    autoComplete="off"
                  />
                </div>
                <div className="col-4 m-0 p-0 pl-2">
                  <Input
                    label="Código:"
                    name="descripcion"
                    ref={txtCodigoUbicacion}
                    disabled
                  />
                </div>
                <div className="col-6 m-0 p-0 pl-2">
                  <Input
                    label="Dirección:"
                    name="direccion"
                    ref={txtDescripcionUbicacion}
                    disabled
                  />
                </div>
              </fieldset>
              <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos Vida Útil
                </legend>
                <div className="col-3 m-0 p-0">
                  <Input
                    label="Original:"
                    name="original"
                    ref={txtOriginal}
                    disabled
                    defaultValue={0}
                    inputClassName="text-end"
                  />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input
                    label="+"
                    name="mas"
                    ref={txtMas}
                    disabled
                    defaultValue={0}
                    inputClassName="text-end"
                  />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input
                    label="-"
                    name="menos"
                    ref={txtMenos}
                    disabled
                    defaultValue={0}
                    inputClassName="text-end"
                  />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input
                    label="Actual:"
                    name="actual"
                    inputClassName="text-end"
                    ref={txtActual}
                    disabled
                    defaultValue={0}
                  />
                </div>
              </fieldset>
            </div>
          </div>
          <div hidden={tab !== 2}>
            <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos del Mueble
              </legend>
              <div className="col-6 m-0 mb-2 p-0">
                <Input
                  label="Código del Bien:"
                  name="codigobien"
                  autoComplete="off"
                  ref={txtCodigoBien}
                  disabled
                />
              </div>
              <div className="col-6 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Código Bienes Nacionales:"
                  name="codigobiennacional"
                  autoComplete="off"
                  ref={txtCodigoBienNacional}
                  disabled
                />
              </div>
              <div className="col-5 m-0 mb-2 p-0">
                <Input
                  label="Marca:"
                  name="marca"
                  autoComplete="off"
                  ref={txtMarca}
                  disabled
                />
              </div>
              <div className="col-5 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Modelo:"
                  name="modelo"
                  autoComplete="off"
                  ref={txtModelo}
                  disabled
                />
              </div>
              <div className="col-2 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Año:"
                  name="anio"
                  autoComplete="off"
                  ref={txtAnio}
                  defaultValue={0}
                  disabled
                  inputClassName="text-end"
                />
              </div>
              <div className="col-5 m-0 mb-2 p-0">
                <Input
                  label="Color:"
                  name="color"
                  autoComplete="off"
                  ref={txtColor}
                  disabled
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Capacidad:"
                  name="capacidad"
                  autoComplete="off"
                  ref={txtCapacidad}
                  disabled
                  defaultValue={0}
                  inputClassName="text-end"
                />
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Tipo:"
                  name="tipo"
                  autoComplete="off"
                  ref={txtTipo}
                  disabled
                />
              </div>
              <div className="col-5 m-0 mb-2 p-0">
                <Input
                  label="Seriales:"
                  name="seriales"
                  autoComplete="off"
                  ref={txtSeriales}
                  disabled
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Numero de Piezas:"
                  name="numpieza"
                  autoComplete="off"
                  ref={txtNumPieza}
                  disabled
                  defaultValue={0}
                  inputClassName="text-end"
                />
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Placa:"
                  name="placa"
                  autoComplete="off"
                  ref={txtPlaca}
                  disabled
                />
              </div>
              <div className="col-6 m-0 p-0">
                <Input
                  label="Uso:"
                  name="uso"
                  autoComplete="off"
                  ref={txtUso}
                  disabled
                />
              </div>
              <div className="col-2 m-0 p-0 pl-2">
                <Input
                  label="Alto:"
                  name="alto"
                  autoComplete="off"
                  ref={txtAlto}
                  disabled
                  defaultValue="0,00"
                />
              </div>
              <div className="col-2 m-0 p-0 pl-2">
                <Input
                  label="Largo:"
                  name="largo"
                  autoComplete="off"
                  ref={txtLargo}
                  disabled
                  defaultValue="0,00"
                />
              </div>
              <div className="col-2 m-0 p-0 pl-2">
                <Input
                  label="Ancho:"
                  name="ancho"
                  autoComplete="off"
                  ref={txtAncho}
                  disabled
                  defaultValue="0,00"
                />
              </div>
              <fieldset className="col-12 m-0 p-2 d-flex gap-2 border-azul rounded">
                <legend className="float-none w-auto m-0">Disposición</legend>
                <div className="col-3 m-0 p-0">
                  <Input
                    ref={txtCodMotivo}
                    disabled
                    label="Cod. Motivo:"
                    name="codmotivo"
                    autoComplete="off"
                  />
                </div>
                <Input
                  label="Descripción:"
                  name="descripcion"
                  autoComplete="off"
                  disabled
                  ref={txtDescripcionMotivo}
                />
              </fieldset>

              <div className="col-12 m-0 my-2 p-0">
                <Textarea
                  label="Observación:"
                  name="observacion"
                  autoComplete="off"
                  ref={txtObservacion}
                  disabled
                  style={{ height: 70 }}
                />
              </div>
            </fieldset>
            <fieldset className="col-12 m-0 p-2 d-flex gap-2  border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos del Responsable Patrimonial
              </legend>
              <div className="col-3 m-0 p-0">
                <Input
                  label=" Cédula de Identidad:"
                  name="cedula"
                  ref={txtCedula}
                  disabled
                />
              </div>
              <Input
                label="Nombre del Responsable:"
                name="nombre_responsable"
                ref={txtNombreResponsa}
                disabled
              />
            </fieldset>
          </div>
          <div hidden={tab !== 3}>
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <div className="col-3 m-0 mb-2 p-0">
                <Input
                  label="Valor Inicial:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="valor_inicial"
                  ref={txtValorInicial}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Valor Rescate:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="valor_rescate"
                  ref={txtValorRescate}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Depressiación Mensual:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="depresacion_mensual"
                  ref={txtDepresiacionMensual}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input
                  label="Depresiación Acumulada:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="depresiacion_acumulada"
                  ref={txtDepresiacionAcumulada}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
              <div className="col-3 m-0 p-0">
                <Input
                  label="Valor Libros:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="valor_inicial"
                  ref={txtValorLibros}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Valor Adición:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="valor_adicion"
                  ref={txtValorAdicion}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Valor Reexpresado:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="valor_reepresado"
                  ref={txtValorReexpresado}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
              <div className="col-3 m-0 p-0 pl-2">
                <Input
                  label="Costo Reposición:"
                  placeholder="0.00"
                  inputClassName="text-end"
                  name="costo_reposicion"
                  ref={txtCostoReposicion}
                  disabled
                  defaultValue="0,00"
                  onFocus={seleccionarCampo}
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
            </div>
          </div>
          <div hidden={tab !== 4}>
            <fieldset className="col-12 m-0 p-2 border-azul rounded">
              <legend className="float-none w-auto m-0">
                Datos del Mueble
              </legend>
              <div className="col-3 m-0 p-0">
                <Input
                  label="Fecha Desincorporación:"
                  name="fechadesincorporacion"
                  type="date"
                  autoComplete="off"
                  ref={txtFechaDesincorporacion}
                  disabled
                  onChange={onChange}
                  onKeyUp={onNextChange}
                />
              </div>
              <fieldset className="col-12 m-0 p-2 d-flex gap-2 border-azul rounded">
                <legend className="float-none w-auto m-0">Disposición</legend>
                <div className="col-3 m-0 p-0">
                  <SearchInput
                    ref={txtCodMotivoDesin}
                    disabled={
                      operacion === 0 || operacion === 3 || operacion === 4
                    }
                    onKeyUp={validarCodigoMotivoDes}
                    onBlur={validarCodigoMotivoDes}
                    label="Cod. Motivo:"
                    name="codmotivo"
                    autoComplete="off"
                    disabledButton={
                      operacion === 0 || operacion === 3 || operacion === 4
                    }
                    onClickButton={() => setMostrarCatalogoMotivoDes(true)}
                  />
                </div>
                <Textarea
                  ref={txtDescripcionMotivoDesin}
                  disabled
                  onChange={onChange}
                  onKeyUp={onNextChange}
                  label="Descripción:"
                  name="descripcion"
                />
              </fieldset>
              <div className="col-12 m-0 mt-2 p-0">
                <Textarea
                  label="Observación:"
                  name="observacion"
                  autoComplete="off"
                  ref={txtObservacionDesincorporacion}
                  disabled
                  onChange={onChange}
                  onKeyUp={onNextChange}
                  style={{ height: 70 }}
                />
              </div>
            </fieldset>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {visibleButton ? (
          <div className="col-12 d-flex m-auto justify-content-between">
            <SuccessButton onClick={() => onClickButton(1)} icon="fas fa-plus">
              Incluir
            </SuccessButton>
            <InfoButton onClick={() => onClickButton(4)} icon="fas fa-search">
              Consultar
            </InfoButton>
            <WarningButton onClick={() => onClickButton(2)} icon="fas fa-edit">
              Editar
            </WarningButton>
            <DangerButton onClick={() => onClickButton(3)} icon="fas fa-trash">
              Eliminar
            </DangerButton>
          </div>
        ) : (
          <div className="col-12 d-flex m-auto justify-content-end">
            <div className="m-1 p-0">
              <InfoButton
                icon="fas fa-print"
                disabled={disabledPrint}
                onClick={() => onClickButton(7)}
              >
                Imprimir
              </InfoButton>
            </div>
            <div className="m-1 p-0">
              <SuccessButton
                disabled={operacion === 4}
                ref={btnAcepta}
                onClick={() => onClickButton(5)}
              >
                Aceptar
              </SuccessButton>
            </div>
            <div className="m-1 p-0">
              <DangerButton ref={btnCancela} onClick={() => onClickButton(6)}>
                Cancelar
              </DangerButton>
            </div>
          </div>
        )}
      </Modal.Footer>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />

      <CatalogoMotivoDesincorporacion
        show={mostrarCatalogoMotivoDes}
        onHide={onHideCatalogoMotivoDes}
      />

      <CatalogoIncorporacionMueble
        show={mostrarCatalogoIncorp}
        onHide={onHideCatalogoIncorp}
      />

      <CatalogoDesincorporacionMueble
        show={mostrarCatalogoDesincorp}
        onHide={onHideCatalogoDesincorp}
      />
    </Modal>
  );
}
